/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PriceBandResponse,
    PriceBandResponseFromJSON,
    PriceBandResponseFromJSONTyped,
    PriceBandResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface PriceBandResponseCriteriaResponse
 */
export interface PriceBandResponseCriteriaResponse {
    /**
     * 
     * @type {PriceBandResponse}
     * @memberof PriceBandResponseCriteriaResponse
     */
    value?: PriceBandResponse;
    /**
     * 
     * @type {boolean}
     * @memberof PriceBandResponseCriteriaResponse
     */
    exclude?: boolean;
}

export function PriceBandResponseCriteriaResponseFromJSON(json: any): PriceBandResponseCriteriaResponse {
    return PriceBandResponseCriteriaResponseFromJSONTyped(json, false);
}

export function PriceBandResponseCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceBandResponseCriteriaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : PriceBandResponseFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function PriceBandResponseCriteriaResponseToJSON(value?: PriceBandResponseCriteriaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': PriceBandResponseToJSON(value.value),
        'exclude': value.exclude,
    };
}


